import { render, staticRenderFns } from "./CompareExpertiseKA.vue?vue&type=template&id=b0a72c5c"
import script from "./CompareExpertiseKA.vue?vue&type=script&lang=js"
export * from "./CompareExpertiseKA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports